export function ContentCleaner (pEditor)
{
  var rgClearHtml1 = /<(?:(?:img|image|embed|iframe)[^>]+src\s*=\s*(?:"|')?|[^>]+url\s*\(|meta[^>]+url\s*=|param[^>]+value\s*=)\s*(?:(?:&#(?:0*(?:[1-9]|[12][0-9]|3[12])|x0*(?:[1-9A-Fa-f]|1[0-9]|20)))\s*)*(?:j(?:&#(?:0*(?:9|10|13)|x0*(?:9|A|D))|[\r\n\t]*)a(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)v(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)a(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)s(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)c(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)r(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)i(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)p(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)t|v(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)b(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)s(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)c(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)r(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)i(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)p(?:&#(?:0*(?:9|10|13)\;?|x0*(?:9|A|D))\;?|[\r\n\t]*)t|(?:&#[^&\:]+){10})\:(?:[^>]*?)>/ig;
  var rgClearHtml10 = /<\/?plaintext(?:\s[^>]*>|>)/ig;
  var rgClearHtml2 = /[A-Za-z0-9]*:\s*expression\([^\s;>]*\)([\s;]?)(?=[^<]*>)/ig;
  var rgClearHtml5 = new RegExp('^[A-Za-z0-9]+\:\/\/', 'i');
  var validateHTMLConfig = null;
  var inContentInnerIds,
      inContentInnerNames;
  var rgSystemElement =
      [
        /(?:^|_)ctl\d{2,3}(?:_|$)/i,
        /(?:^|\$)ctl\d{2,3}(?:\$|$)/i
      ];


  function clearHTML (htmlString)
  {
    var i, elements;
    var htmlContainer = document.implementation.createHTMLDocument('ClearHTMLContainer').body;

    htmlString = htmlString.replace(rgClearHtml1, '').replace(rgClearHtml10, '').replace(rgClearHtml2, ' ');
    htmlContainer.innerHTML = '&nbsp;' + htmlString;

    elements = htmlContainer.getElementsByTagName('IFRAME');

    for (i = 0; i < elements.length; i++)
    {
      if ((elements[i].src.indexOf(pEditor.$winContent.location.protocol + '//' + pEditor.$winContent.location.host) == 0 || !rgClearHtml5.test(elements[i].src)) &&
          !elements[i].src.match(/^(?:https?:\/\/[^\/]+)?(?:\/resources\/|\/Common\/Editor\/ContentModules\/ContentModuleEditor\.aspx)/i))
      {
        elements[i].parentNode.removeChild(elements[i]);
        i--;
      }
    }

    htmlString = htmlContainer.innerHTML.replace(/^\s*&nbsp;/i, '');
    htmlString = htmlString.trim();

    return htmlString;
  }


  this.getCleanHTML = (isSafeModules, isSetEmailTimeCounter, args = {}) =>
  {
    var i = 0,
        n, k,
        co = 0,
        content,
        elements,
        element,
        attributes,
        nodeName,
        htmlContainer = document.implementation.createHTMLDocument('GetCleanHTMLContainer').body,

        delElements =
          'DIV[data-waelementhidecursor],' +
          'DIV[data-wawebkitpastecontainer],' +
          'ABBR[data-wawebkitcopymarker],' +
          'ABBR[data-wawebkitcopyendpointer],' +
          'SPAN[data-wainsertpointer],' +
          'SPAN[data-wainsertpointerforimage],' +
          'SPAN[data-wainsertpointerforarttext]',

        delAttributes =
        [
          'data-componentid',
          'data-editablearea',
          'data-areaheight',
          'data-autoabs',
          'data-newarttextmark',
          'data-selected',
          'data-watmpid',
          'data-initwidth',
          'data-initheight',
          'data-washiftenterbr',
          'data-walastenterdiv',
          'data-wawebkitdoubletagindex',
          'data-wanewdivider',
          'data-wacurrentarttextpicture',
          'data-wacurrentimage',
          'data-wafixwebkitbackcolor',
          'data-wacopystyleblocktag',
          'data-waelementmarker',
          'data-wasaveattributes',
          'data-wafontindex',
          'data-wablockformattingitemindex',
          'data-wasetfontsize',
          'data-wamultieditorindex'
        ],

        conditionalDelAttributes =
        [
          {
            conditional: (args.isDeleteLayoutMarkup || !pEditor.iFrameDoc.body.querySelector('[data-wacustomemaillayout]')),
            attributes:
            [
              'data-layoutid',
              'data-layouttypography',
              'data-layoutstyle',
              'data-cellouter',
              'data-cellinner',
              'data-innereditablearea',
              'data-maincontent',
              'data-excesscontent',
              'data-cellborder',
              'data-inlinercontainer',
              'data-wainlineremailstyle',
              'data-bodystyles'
            ]
          }
        ];

    if (BEditor.EditorsManager.getBrowserIsValid())
    {
      collectInContentInnerId();

      if (args.isFixBigImageWidth)
      {
        pEditor.image.fixBigImageWidth(true);
      }

      pEditor.htmlFragment = pEditor.htmlFragmentWin.document.body; //TODO:Dime ???!!! IE bug "PD"
      htmlContainer.innerHTML = pEditor.iFrameDoc.body.innerHTML;

      if (args.isFixBigImageWidth)
      {
        pEditor.image.fixBigImageWidth(false);
      }

      elements = htmlContainer.getElementsByTagName('*');

      while (i < elements.length)
      {
        element = elements[i];
        nodeName = element.nodeName.toUpperCase();

        if (validateHTMLConfig && validateHTMLConfig.invalidTags[nodeName])
        {
          element.parentNode.removeChild(element);
        }
        else if (!element.id && element.getAttribute('data-autoabs') && !element.getAttribute('data-selected') &&
                  nodeName === 'DIV' && pEditor.$Style(element, 'position') === 'absolute' && element.innerHTML.replace(/(<br>|\s|&nbsp;)+/ig, '') === '')
        {
          element.parentNode.removeChild(elements[i]);
        }
        else if ((nodeName === 'SPAN' || (nodeName === 'A' && !element.getAttribute('name'))) && element.innerHTML === '')
        {
          element.parentNode.removeChild(element);
        }
        else
        {
          if (checkSystemElement(element, co))
          {
            i++;
          }
        }

        co++;
      }

      elements = htmlContainer.querySelectorAll(delElements);

      for (i = elements.length; i--;)
      {
        if (elements[i] && elements[i].parentNode)
        {
          elements[i].parentNode.removeChild(elements[i]);
        }
      }

      elements = htmlContainer.querySelectorAll('[' + delAttributes.join('],[') + ']');

      for (i = elements.length; i--;)
      {
        element = elements[i];

        if (element && element.parentNode)
        {
          for (n = 0; n < delAttributes.length; n++)
          {
            element.removeAttribute(delAttributes[n]);
          }
        }
      }

      for (k = 0; k < conditionalDelAttributes.length; k++)
      {
        if (conditionalDelAttributes[k].conditional)
        {
          attributes = conditionalDelAttributes[k].attributes;
          elements = htmlContainer.querySelectorAll('[' + attributes.join('],[') + ']');

          for (i = elements.length; i--;)
          {
            element = elements[i];

            if (element && element.parentNode)
            {
              for (n = 0; n < attributes.length; n++)
              {
                element.removeAttribute(attributes[n]);
              }
            }
          }
        }
      }

      pEditor.helpers.fixers.setFixGeckoTables({'htmlSource': htmlContainer, 'isRemove': true});
      pEditor.style.normalizer.fixWebKitHTMLInline(htmlContainer, htmlContainer.ownerDocument);
      pEditor.anchor.restoreLinksToAnchors(htmlContainer);
      removeEmptyP(htmlContainer);

      if (BEditor.browser.isIE)
      {
        pEditor.helpers.fixers.fixIELastLineRemoveFixer(htmlContainer, htmlContainer.ownerDocument);
      }

      content = htmlContainer.innerHTML;
      content = pEditor.helpers.linkFixer.fixRelativeUrls(content);
      checkSystemScriptInUserScripts();
      content = pEditor.helpers.userJavascript.restore(content, true);
      content = pEditor.anchor.restoreAnchors(content);
      content = pEditor.style.normalizer.convertDifferentTags(content);

      if (validateHTMLConfig)
      {
        content = clearInvalidHTML(content);
      }

      content = clearHTML(content);
    }
    else if (pEditor.content.isInTextArea)
    {
      content = pEditor.inContainer.value;

      if (validateHTMLConfig)
      {
        content = clearInvalidHTML(content);
      }

      content = clearHTML(content);
    }
    else
    {
      return '';
    }

    return content;
  };


  function clearInvalidHTML (content)
  {
    content = content.replace(/<(?:\?[\S\s]*?\??|#[\S\s]*?#|%[\S\s]*?%|!--[\S\s]*?--)>/g, '');

    content = content.replace(/<+(\/?[A-Za-z0-9]+)(\s[^>]*>+|\/[^>]*>+|>+|[\S\s]*$)/g, function(bigStr, tagName, tagBody)
    {
      var endTag = (tagName.indexOf('/') == 0) ? '/' : '';
      tagBody = tagBody.substr(0, tagBody.length - 1);

      if (endTag != '')
      {
        tagName = tagName.substr(1);
      }

      if (validateHTMLConfig.validTags[tagName.toUpperCase()])
      {
        if (tagBody.replace(/\s+/g, '') != '')
        {
          tagBody = tagBody.replace(/\s+(\S+?)(?:(?=\s|$)|\s*=(\s*'[\S\s]*?'|\s*"[\S\s]*?"|\S*?(?=\s|$)))/g, function(bigStr, attName, attBody)
            {
              if (validateHTMLConfig.validTags[tagName.toUpperCase()][attName.toLowerCase()] && attBody != null)
              {
                attBody = attBody.replace(/^\s+([\S\s]*?)\s+$/, '$1');
                var sep = (attBody.indexOf("'") == 0) ? "'" : ((attBody.indexOf('"') == 0) ? '"' : '');

                if (sep == "'")
                {
                  attBody = attBody.replace(/^'+([\S\s]*?)'+$/, '$1');
                }
                else if (sep == '"')
                {
                  attBody = attBody.replace(/^"+([\S\s]*?)"+$/, '$1');
                }

                attBody = validateHTMLConfig.validTags[tagName.toUpperCase()][attName.toLowerCase()](attBody);
                return ((attBody) ? ' ' + attName + '=' + sep + attBody + sep : '');
              }
              else
              {
                return '';
              }
            });

          return '<' + endTag + tagName + tagBody + '>';
        }
        else
        {
          return '<' + endTag + tagName + '>';
        }
      }
      else
      {
        return '';
      }
    });

    return content;
  }


  this.checkInsertedContainer = () => //TODO:Dime Create "remover" for system elements (use "data-" attributes)
  {
    var i,
        elements = pEditor.iFrameDoc.body.querySelectorAll('[id="' + pEditor.iFrameDoc.body.id + '"]');

    if (elements.length > 0)
    {
      for (i = elements.length; i--;)
      {
        elements[i].removeAttribute('id');
      }
    }
  };


  function collectInContentInnerId ()
  {
    var i;
    var elements = pEditor.inContainer.getElementsByTagName('*');

    inContentInnerIds = {};
    inContentInnerNames = {};

    for (i = 0; i < elements.length; i++)
    {
      if (elements[i].id && elements[i].id.replace(/\s+/g, '') != '')
      {
        inContentInnerIds[elements[i].id] = true;
      }

      if (elements[i].name && elements[i].name.replace(/\s+/g, '') != '')
      {
        inContentInnerNames[elements[i].name] = true;
      }
    }
  }


  function checkSystemElement(element, co)
  {
    var elementId = element.id;
    var elementName = element.name;

    if (element.nodeName.toUpperCase() == 'SCRIPT')
    {
      element.parentNode.removeChild(element);
      return false;
    }

    if ((elementId && !inContentInnerIds[elementId] && (BEditor.domHelpers.$(elementId) || rgSystemElement[0].test(elementId) || (elementId.indexOf('_') != -1 && elementId.length > 64))) ||
      (elementName && !inContentInnerNames[elementName] && (rgSystemElement[1].test(elementName) || (elementName.indexOf('_') != -1 && elementName.length > 64))))
    {
      if (element.nodeName.toUpperCase() == 'INPUT' && element.type.toLowerCase() == 'hidden')
      {
        element.parentNode.removeChild(element);
        return false;
      }

      element.removeAttribute('id');
      element.removeAttribute('name');
    }

    return true;
  }


  function checkSystemScriptInUserScripts()
  {
    var i;

    for (i = 0; i < pEditor.helpers.userJavascript.scripts.length; i++)
    {
      if (pEditor.helpers.userJavascript.scripts[i])
      {
        if (pEditor.helpers.userJavascript.scripts[i].src)
        {
          if (checkSystemScript(pEditor.helpers.userJavascript.scripts[i].src, null))
          {
            pEditor.helpers.userJavascript.scripts[i] = null;
          }
        }
        else if (pEditor.helpers.userJavascript.scripts[i].content)
        {
          if (checkSystemScript(null, pEditor.helpers.userJavascript.scripts[i].content))
          {
            pEditor.helpers.userJavascript.scripts[i] = null;
          }
        }
      }
    }
  }


  function checkSystemScript(scriptSrc, scriptContent)
  {
    if (scriptSrc)
    {
      if (scriptSrc.indexOf(pEditor.$winContent.location.protocol + '//' + pEditor.$winContent.location.host) == 0 || scriptSrc.indexOf('http') != 0)
      {
        scriptSrc = scriptSrc.replace(/^([^?#]*)[?#].*$/, '$1');

        if (scriptSrc.indexOf('/resources/') == -1)
        {
          return true;
        }
      }
    }
    else if (scriptContent)
    {
      if (scriptContent.indexOf('BonaPage.setPageState') != -1 ||
          scriptContent.indexOf('AdminPanel.') != -1 ||
          scriptContent.indexOf('Sys.') != -1 ||
          scriptContent.indexOf('Page_ValidationSummaries') != -1 ||
          scriptContent.indexOf('Page_Validators') != -1 ||
          scriptContent.match(/function\s+__doPostBack/) ||
          scriptContent.match(/function\s+WebForm_OnSubmit/) ||
          scriptContent.match(/function\s+poweredbyChange/) ||
          scriptContent.match(/function\s+callAddPagePostback/) ||
          scriptContent.match(/function\s+callRevertChangesPostback/) ||
          scriptContent.match(/function\s+ValidatorOnSubmit/) ||
          scriptContent.match(/_ActionPanel\d+_/))
      {
        return true;
      }
    }

    return false;
  }


  this.removeStyles = (parentElement, styles) =>
  {
    var i, n,
        attrs,

      delTags =
      {
        'FONT': true, 'BIG': true, 'SMALL': true, 'B': true, 'STRONG': true, 'I': true, 'EM': true, 'U': true, 'CENTER': true, 'SUP': true, 'SUB': true
      },

      delAttrs =
      [
        'face', 'size', 'color', 'bgcolor', 'align'
      ],

      delStyles =
      [
        'blockTag', 'fontFamily', 'fontSize', 'color', 'backgroundColor', 'fontWeight', 'fontStyle', 'textDecoration', 'textAlign', 'verticalAlign'
      ],

      elements = parentElement.getElementsByTagName('*');

    for (i = elements.length; i--;)
    {
      if (delTags[elements[i].nodeName.toUpperCase()])
      {
        elements[i].outerHTML = elements[i].innerHTML;
      }
      else
      {
        attrs = elements[i].attributes;

        for (n = attrs.length; n--;)
        {
          if (delAttrs[attrs[n].name.toLowerCase()])
          {
            element.removeAttribute(attrs[n].name);
          }
        }

        for (n = delStyles.length; n--;)
        {
          if (elements[i].style[delStyles[n]] != null && elements[i].style[delStyles[n]] != '')
          {
            elements[i].style[delStyles[n]] = '';
          }
        }

        if (elements[i].getAttribute('style') == '')
        {
          elements[i].removeAttribute('style');
        }
      }
    }

    pEditor.range.cursor.show(parentElement, false);
  };


  function removeEmptyP (container)
  {
    container = container || pEditor.iFrameDoc.body;

    var i,
        ind,
        hash = [],
        htmlContent,
        matchP,
        matchInd,
        element,
        elements = container.getElementsByTagName('P');

    var reCheckIEEmptyP = /<p(?:\s[^>]*>|>)</ig,
        reGetDataWaContent = /\sdata-wacontent\s*=\s*['"]?(\d+)/i;

    for (i = elements.length; i--;)
    {
      element = elements[i];
      ind = element.getAttribute('data-wacontent');

      if (ind != null && ind !== '')
      {
        ind = parseInt(ind);

        if (!isNaN(ind) && !hash[ind])
        {
          hash[ind] = true;
        }
        else
        {
          ind = null;
        }
      }
      else
      {
        ind = null;
      }

      if (ind === null)
      {
        ind = pEditor.waContentMarkerCounter++;
        hash[ind] = true;
        element.setAttribute('data-wacontent', ind);
        element.setAttribute('data-wacontenttag', element.tagName);
      }

      if (!BEditor.browser.isIE)
      {
        if (element.innerHTML === '')
        {
          if (!element.hasAttribute('data-wapreserve') && element.style.width === '' && element.style.height === '' && element.parentNode)
          {
            element.parentNode.removeChild(element);
          }
        }
      }
    }

    if (BEditor.browser.isIE)
    {
      htmlContent = pEditor.iFrameDoc.body.innerHTML;

      while (matchP = reCheckIEEmptyP.exec(htmlContent))
      {
        matchInd = reGetDataWaContent.exec(matchP[0]);

        if (matchInd && matchInd.length === 2)
        {
          ind = matchInd[1];

          if (ind != null && ind !== '')
          {
            element = pEditor.iFrameDoc.body.querySelector('P[data-wacontent="' + ind + '"]');

            if (element.innerHTML === '')
            {
              element.parentNode.removeChild(element);
            }
          }
        }
      }
    }
  }


  this.clearHTML = clearHTML;
  this.removeEmptyP = removeEmptyP;
}